export enum VinValidationError {
    ERROR_INVALID_LENGTH,
    ERROR_INVALID_FORMAT,
    ERROR_NO_MANUALS
}